import React, { useState } from "react";
import { useGoogleLogin } from "@react-oauth/google";
import { useNavigate } from "react-router-dom";
import { setDataOnLocalStorage } from "../util/localStorage";
import useApi from "../hooks/useApi"; // Custom hook
import { baseUrl } from "../config/apiConfig";
import AI_PDF_CONST from "../util/PdfAiConst";
import ErrorPopUpComponent from "./ErrorPopUpComponent";

const GoogleLoginComponent = () => {
  const { callApi, loading } = useApi(); // Use the custom hook
  const [errorMessage, setErrorMessage] = useState("");
  const [isMessageShow, setIsMessageShow] = useState(false);
  const navigate = useNavigate();

  // ✅ Updated login using useGoogleLogin
  const login = useGoogleLogin({
    scope: "openid profile email https://www.googleapis.com/auth/gmail.readonly",
    onSuccess: async (response) => {
      console.log("Google Login Success:", response);
      setIsMessageShow(false);
      setErrorMessage("");

      try {
        // Get access token
        const accessToken = response.access_token;

        // Fetch user profile from Google (to get email, picture, etc.)
        const userInfoRes = await fetch(
          "https://www.googleapis.com/oauth2/v3/userinfo",
          {
            headers: { Authorization: `Bearer ${accessToken}` },
          }
        );
        const userInfo = await userInfoRes.json();
        console.log("User Info:", userInfo);

        const data = await callApi(
          `${baseUrl + AI_PDF_CONST.API_ENDPOINT.LOGIN}`,
          "POST",
          { source: "google", token: accessToken }
        );

        // Save backend token
        setDataOnLocalStorage("token", data.data.access_token);

        const userObj = {
          auth_id: data.data.auth_id,
          auth_source: data.data.auth_source,
          email: data.data.email || userInfo.email,
          id: data.data.id,
          name: data.data.name || userInfo.name,
          userProfileImg: userInfo.picture,
        };
        setDataOnLocalStorage("userInfo", userObj);

        // Redirect to dashboard
        navigate("/dashboard");
      } catch (err) {
        console.error("Login failed:", err.message);
        setIsMessageShow(true);
        setErrorMessage("Login failed. Please try again.");
      }
    },
    onError: () => {
      console.error("Google login failed.");
      setIsMessageShow(true);
      setErrorMessage("Google login failed. Please try again.");
    },
  });

  return (
    <div className="w-full">
      {loading ? (
        <div className="flex justify-center py-3">
          <div className="dot-pulse"></div>
        </div>
      ) : (
        <button onClick={() => login()} className="flex items-center justify-center w-full bg-white border border-gray-300 rounded-lg px-6 py-3 text-gray-700 font-medium hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-200 transition-colors duration-200 shadow-sm">
          <svg className="w-5 h-5 mr-3" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
            <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
            <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
            <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
          </svg>
          Sign in with Google
        </button>
      )}
      <ErrorPopUpComponent
        isErrorShow={isMessageShow}
        errorMessage={errorMessage}
        redirect=""
      />
    </div>
  );
};

export default GoogleLoginComponent;
